// hint >>>> https://stackoverflow.com/questions/9153445/how-to-communicate-between-iframe-and-the-parent-site

export const onClose = (event) => {
	window.parent.postMessage(
		JSON.stringify({ type: 'CLOSE_CONSENT_IFRAME' }),
		'*',
	);
};
